// src/services/globalSearch.js

import api from '../api/axios';

/**
 * Ricerca globale su contatti, task, appuntamenti e leads.
 * Usa Promise.allSettled così se un endpoint fallisce gli altri funzionano.
 */
export const globalSearch = async (query) => {
  if (!query || query.trim().length < 2) {
    return { contacts: [], tasks: [], events: [], leads: [] };
  }

  const [contacts, tasks, events, leads] = await Promise.allSettled([
    api.get('api/contacts/contacts/', { params: { search: query } }),
    api.get('api/tasks/tasks/', { params: { search: query } }),
    api.get('api/appointments/appointments/', { params: { search: query } }),
    api.get('api/leads/leads/', { params: { search: query } }),
  ]);

  const extract = (result) => {
    if (result.status !== 'fulfilled') return [];
    const data = result.value.data;
    return (data.results || data || []).slice(0, 5);
  };

  return {
    contacts: extract(contacts),
    tasks: extract(tasks),
    events: extract(events),
    leads: extract(leads),
  };
};
